import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { formatDate, isUserMentor } from "../../utils/helper";

export default function ShowDetailsDialog({
  isOpen,
  setIsOpen,
  selectedMentor,
}) {
  function closeModal() {
    setIsOpen(false);
  }

  const isMentor = isUserMentor();

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-3xl p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Mentor Details
                </Dialog.Title>
                <div className="flex flex-col mt-6">
                  <div className="flex flex-row border-b border-b-[#EBEBEB] ">
                    <div className="flex w-2/4 items-start   border-r border-r-[#EBEBEB] pb-4">
                      <img
                        className="mr-4 rounded-full w-28 h-2w-28"
                        src={
                          selectedMentor?.profile || !isMentor
                            ? "/assets/consultant.jpg"
                            : "https://img.freepik.com/premium-vector/man-professional-business-casual-young-avatar-icon-illustration_1277826-632.jpg"
                        }
                        alt="Profile"
                      />
                      <div>
                        <h2 className="text-xl font-normal text-black">
                          {selectedMentor?.firstName} {selectedMentor?.lastName}
                        </h2>
                        <p className="text-gray-600">
                          {selectedMentor?.specialization}
                        </p>
                        <p className="text-sm text-gray-500">
                          Experience - {selectedMentor?.experience} Years
                        </p>
                        <div className="flex text-yellow-400">
                          {"★".repeat(5)}
                        </div>
                        <div className="space-y-1">
                          <p className="text-[#5F5F5F] text-sm">
                            {selectedMentor?.minutesCompleted} mins completed
                          </p>
                          <p className="text-[#5F5F5F] text-sm">
                            Advised {selectedMentor?.candidatesAdvised}{" "}
                            candidates
                          </p>
                          <p className="text-sm font-medium text-black">
                            ₹{selectedMentor?.chargePerMinutes}/- per minute
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="w-2/4 px-4 space-y-2">
                      <h2 className="font-normal text-black text-md">
                        Description:
                      </h2>
                      <p className="text-sm text-gray-500">
                        {selectedMentor?.description}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-row ">
                    <div className=" w-2/4  space-y-2  border-r border-r-[#EBEBEB] py-4 ">
                      <h2 className="font-normal text-black text-md">
                        Education:
                      </h2>
                      {selectedMentor?.education?.length > 0 ? (
                        selectedMentor?.education.map((edu, index) => (
                          <div key={index}>
                            <h2 className="font-semibold text-black text-md">
                              {edu.name}
                            </h2>
                            <p className="text-sm text-gray-500">
                              {edu?.degree}
                            </p>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="w-2/4 px-4 py-4 space-y-2">
                      <h2 className="font-normal text-black text-md">
                        Experience:
                      </h2>
                      {selectedMentor?.work?.length > 0 ? (
                        selectedMentor?.work.map((edu, index) => (
                          <div key={index}>
                          <div className="flex items-center justify-between" > 
                          <h2 className="font-semibold text-black text-md">
                              {edu.name}
                            </h2>
                            <span className="text-xs font-normal text-gray-500">
                              {formatDate(edu?.startDate)} -{" "}
                              {formatDate(edu?.endDate)}
                            </span>
                          </div>
                            <p className="text-sm text-gray-500">{edu?.role}</p>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
